import { Tag } from "@blueprintjs/core";
import React from "react";
import { niceDateTime } from "../fns/util";

class LastUpdated extends React.Component {
  render() {
    return (
      <Tag minimal={this.props.minimal} rightIcon="history">
        Last Updated: {niceDateTime(this.props.data.updatedAt)}
      </Tag>
    );
  }
}

export default LastUpdated;
